import React from 'react';

import { Link } from 'react-router-dom';

import { StyledCTA } from './CTA.styled';

const CTA = () => {
  return (
    <StyledCTA>
      <h1>Stories worth reading.</h1>
      <p>
        A clean, minimal blog powered by Prismic. Explore articles on topics
        that matter.
      </p>
      <Link to="/articles">Browse articles</Link>
    </StyledCTA>
  );
};

export default CTA;
